import { t } from "i18next";
import * as z from "zod";

import { compactIdentifier } from "@/core/utils/func/input-normalization";
import { BENEFICIARY_TYPES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire d'ajout d'un bénéficiaire (`POST /Beneficiaries/add`).
 *
 * Factory (règle projet) : créé via `createBeneficiarySchema()` et mémoïsé
 * au niveau composant sur la langue courante — jamais d'instance exportée.
 * `walletId` est fourni par le contexte (portefeuille courant), pas saisi.
 */
export const createBeneficiarySchema = () =>
  z.object({
    walletId: z.string().trim().min(1, { message: t("requiredFieldError") }),
    label: z.string().trim().min(1, { message: t("requiredFieldError") }),
    type: z.enum(BENEFICIARY_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    institutionCode: z.string().trim().or(z.literal("")),
    accountNumber: z
      .string()
      .transform((raw) => compactIdentifier(raw.trim()))
      .refine((value) => value.length > 0, {
        message: t("requiredFieldError"),
      }),
    isFavorite: z.boolean().optional(),
  });

export type BeneficiaryFormValues = z.infer<
  ReturnType<typeof createBeneficiarySchema>
>;
